import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="4" y="8" width="18" height="15" rx="2" fill="#fff" /><path d="M20.124 16.31a1 1 0 010-1.62l6.29-4.541a1 1 0 011.586.81v9.081a1 1 0 01-1.585.811l-6.291-4.54z" fill="#fff" /></svg>);